export default __webpack_public_path__ + "static/media/DSC_7997.770b7745.jpg";